export const keyShiftEdges = {
  'shift+down': 'bottom',
  'shift+left': 'left',
  'shift+right': 'right',
  'shift+up': 'top',
};

export const MIN_COLUMN_HEIGHT = 48;
